module.exports = __webpack_public_path__ + "static/img/pc_hd_activity1_content3_img.fa03735.png";